import { EditGridColumnType } from "../../../../../../components/molGrid/libs/data/editGridColumnType";

export const manageXMLReportDataGridConfig = {
  isRowSelectable: false,
  allowEdit: false,
  hasChildGridTable: false,
  columns: [
    {
      name: "SchemaFieldName",
      fieldName: "displayName",
      colStyle: {
        textAlign: "left",
        width: "30%",
      },
      allowShort: false,
    },
    {
      name: "SchemaFieldType",
      fieldName: "schemaFieldType",
      colStyle: {
        textAlign: "left",
        width: "26%",
      },
      editColValidation: [
        { type: "required", message: "WorkingDays  is required." },
      ],
      allowShort: false,
    },
    {
      name: "Value",
      fieldName: "valFieldValue",
      allowShort: false,
      allowEditColumn: true,
      editColumn: {
        editColType: EditGridColumnType.INPUT,
        placeholder: "Value",
        editColFieldName: "value",
        isDisable: false,
        colConfig: {
          isReadOnly: false,
        },
        editColValidation: [
        ],
      },
      colStyle: {
        textAlign: "left",
        width: "18%",
      },
    },
    {
      name: "OverrideValue",
      fieldName: "valFieldOverride",
      allowShort: false,
      allowEditColumn: true,
      editColumn: {
        editColType: EditGridColumnType.INPUT,
        placeholder: "Override Value",
        editColFieldName: "overrideValue",
        isDisable: false,
        colConfig: {
          isReadOnly: false,
        },
        editColValidation: [
        ],
      },
      colStyle: {
        textAlign: "left",
        width: "18%",
      },
    },

  ],
  editSettings: {
    buttons: {
      save: true,
      cancel: true,
    },
  },
  handleRowDataUpdate: null,
  OnColumnChangeEdit: null,
};
